<div class="fwc-container">
  <div class="fwc-row a-center j-center account-bar">
    <div class="account-sel-cont">
      <label for="university-select" class="right-xxs"><h6>Viewing as:</h6></label>
      <div id="univ-select" class="fwc-select-list">
        <select name="universities" id="university-select" [(ngModel)]='universitySelect' (change)="storySelect($event)" aria-label="Select university account">
          @for (story of stories; track story) {
            <option [value]="story.id">
              {{story.label}}
            </option>
          }
        </select>
      </div>
    </div>
  </div>
</div>
